import React from 'react';
import { Route, Switch } from "react-router-dom";
import IssuerReportsModule from "./issuer-reports-module/issuer-reports-module";

const Issuer_Reports = () => {
  return (
    <Switch>
      <Route exact path="/Issuer_Reports">
        <IssuerReportsModule />
      </Route>
    </Switch>
  )
}

export default Issuer_Reports;



